import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["disabled"]

import AddToBasketButtonContent from '@/shared/form/AddToBasketButtonContent.vue';
import { computed, Ref, ref } from 'vue';
import basketStore from '@/shared/checkout/basket/basket.store';
import { useBlockLabels } from '@/shared/content/blocks/helpers/block-labels.plugin';
import useOutletProductDetailData from '@/shared/product/details/ui/outlet/useOutletProductDetailData';
import useBasket from '@/storecontext/basket/useBasket';
import WebApiMessage from '@/core/http/WebApiMessage.vue';
import authStore from '@/shared/auth/auth.store';
import { PurchaseOptionType } from '@/types/productServerApi';
import useProductAddOns from '@/shared/product/add-ons/useProductAddOns';
import basketTrackingService from '@/shared/tracking/basket-tracking.service';
import { useAddToBasket } from '@/storecontext/product/purchase/useAddToBasket';


export default /*#__PURE__*/_defineComponent({
  __name: 'OutletProductDetailPurchase',
  setup(__props) {

const labels = useBlockLabels();

const { outletProductData } = useOutletProductDetailData();
const { addOutletItem, addInstant, get } = useBasket();
const { addAddOnsToBasket, hasSelectedAddOns: hasAddedMultiple, addedAddOnsLabel } = useProductAddOns();
const { addToBasket } = useAddToBasket();

const productIsAtCentralHub = computed(() => !outletProductData.value.outletLocation || outletProductData.value.outletLocation.isStorage);
const productIsAtCurrentStoreContext = computed(() => !outletProductData.value.outletLocation?.isStorage && outletProductData.value.outletLocation?.storeId === authStore.storeId);
const showAddToBasketButton = computed(() => productIsAtCentralHub.value || productIsAtCurrentStoreContext.value);

const pending: Ref<boolean> = ref(false);

const messageId = `outletAddToBasket${outletProductData.value.recId}`;

const submit = async(): Promise<void> => {
    basketTrackingService.outlet(outletProductData.value);
    if (!pending.value) {
        pending.value = true;
    }

    if (productIsAtCurrentStoreContext.value && outletProductData.value.inventSerial) {
        await Promise.all([addInstant({ itemId: outletProductData.value.inventSerial, quantity: 1 }, messageId), addAddOnsToBasket(addToBasket, PurchaseOptionType.Instant)]);
    } else {
        await Promise.all([addOutletItem({ recId: outletProductData.value.recId }, messageId), addAddOnsToBasket(addToBasket)]);
    }

    await getOutletItemStockStatus();

    pending.value = false;
    if (hasAddedMultiple.value) {
        get();
    }
};

const isOutletItemInStock = ref(true);

const getOutletItemStockStatus = async(): Promise<void> => {
    isOutletItemInStock.value = await basketStore.outletItemInStock(outletProductData.value.recId);
};

const basketButtonDefaultText = computed(() => isOutletItemInStock.value ? labels.addToBasket : labels.notInStock);
const basketButtonAddedText = computed(() => addedAddOnsLabel.value ? addedAddOnsLabel.value : labels.addedToBasket);

getOutletItemStockStatus();


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(showAddToBasketButton))
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          type: "submit",
          disabled: !isOutletItemInStock.value,
          class: "c-button c-button--primary min-w-220 transition-colors mt-x4 md:mt-x5",
          onClick: submit
        }, [
          _createVNode(AddToBasketButtonContent, {
            pending: pending.value,
            "added-button-text": _unref(basketButtonAddedText),
            "default-button-text": _unref(basketButtonDefaultText)
          }, null, 8, ["pending", "added-button-text", "default-button-text"])
        ], 8, _hoisted_1))
      : _createCommentVNode("", true),
    _createVNode(WebApiMessage, {
      id: messageId,
      "clear-timing": 5000
    })
  ], 64))
}
}

})